let timeout;
const filterableItemSelector = ".Measure";
const filterListSelector = ".FilterList";
const filterListItemSelector = ".FilterList__item";
const filterListItemCheckboxSelector = ".FilterList__item-input";
const allToggleSelector = ".FilterList__item-input--all";
const animationDuration = 200; // in animate.css
const animateInClasses = "animated fadeInUp";
const animateOutClasses = "animated fadeOut hidden";

/** @param {JQuery} $el */
function toggleNearestCheckbox($el) {
	let $checkboxEl = $el
		.parents(filterListItemSelector)
		.find(filterListItemCheckboxSelector);
	if ($checkboxEl.attr("data-is-animating")) {
		return false;
	}
	// Don't need to do anything cause it's an already selected radio
	if ($checkboxEl.attr("type") == "radio" && $checkboxEl.is(":checked")) {
		return false;
	}
	$checkboxEl.prop("checked", !$checkboxEl.prop("checked"));
	$checkboxEl.trigger("change");
}

/**
 * @param {JQuery} $filterList
 * @param {JQuery} $checkedItems
 * @param {JQuery} $allCheckableItemsExceptAll
 */
function toggleSelectAllCheckboxIn(
	$filterList,
	$checkedItems,
	$allCheckableItemsExceptAll,
) {
	const $allToggleCheckbox = $filterList.find(allToggleSelector);
	$allToggleCheckbox.prop(
		"checked",
		$checkedItems.length == $allCheckableItemsExceptAll.length,
	);
}

/** @param {JQuery} $filterList */
function checkedItemsIn($filterList) {
	return $filterList
		.find(`${filterListItemCheckboxSelector}:checked`)
		.not(allToggleSelector);
}

/** @param {JQuery} $filterList */
function checkedValsIn($filterList) {
	return $.makeArray(
		checkedItemsIn($filterList).map((_idx, checkedItem) => {
			return /** @type {string} */ ($(checkedItem).val());
		}),
	);
}

/** @param {string[]} checkedItemVals */
function createSelectorsFrom(checkedItemVals) {
	return checkedItemVals.map((checkedItemVal) => {
		return `.Measure[data-measure-category-id='${checkedItemVal}']`;
	});
}

/** @param {JQuery} $filterables */
function resetClassesFor($filterables) {
	$filterables
		.removeClass("hidden")
		.removeClass(animateInClasses)
		.removeClass(animateOutClasses);
}

/** @param {JQuery} $filterables */
function animateFilterablesIn($filterables) {
	resetClassesFor($filterables);
	$filterables.addClass(animateInClasses);
}

/** @param {JQuery} $filterables */
function animateFilterablesOut($filterables) {
	if (timeout) {
		clearTimeout(timeout);
	}
	resetClassesFor($filterables);
	$filterables.addClass(animateOutClasses);
	timeout = window.setTimeout(function () {
		$filterables.addClass("hidden");
	}, animationDuration);
}

/** @param {JQuery} $filterableContainer */
function initPrevSelected($filterableContainer) {
	const checkedVals = checkedValsIn(
		$filterableContainer.find(filterListSelector),
	);
	setPrevState($filterableContainer, checkedVals);
}

/**
 * @param {JQuery} $filterableContainer
 * @param {string[]} valsArray
 */
function setPrevState($filterableContainer, valsArray) {
	$filterableContainer.attr("data-prev-selected", valsArray.join(","));
}

/** @param {JQuery} $checkboxEl */
function rejectDoubleClickOnCheckbox($checkboxEl) {
	if ($checkboxEl.attr("data-is-animating")) {
		$checkboxEl.prop("checked", !$checkboxEl.prop("checked")); //reverse the click
		return true;
	}

	$checkboxEl.attr("data-is-animating", "true");
	let clickTimeout = setTimeout(function () {
		$checkboxEl.removeAttr("data-is-animating");
		clearTimeout(clickTimeout);
	}, animationDuration);
	return false;
}

/** @param {string} filterableContainerSelector */
function init(filterableContainerSelector) {
	const $filterableContainer = $(filterableContainerSelector);
	const $filterList = $filterableContainer.find(filterListSelector);

	initPrevSelected($filterableContainer);
	$(document)
		.off("click", `${filterableContainerSelector} .FilterList__item-name`)
		.on(
			"click",
			`${filterableContainerSelector} .FilterList__item-name`,
			function (e) {
				toggleNearestCheckbox($(e.currentTarget));
			},
		);

	$(document)
		.off(
			"change",
			`${filterableContainerSelector} ${filterListItemCheckboxSelector}`,
		)
		.on(
			"change",
			`${filterableContainerSelector} ${filterListItemCheckboxSelector}`,
			function () {
				if ($filterableContainer.length > 1) {
					console.error("Should init with a unique container");
				}
				const $checkboxEl = $(this);

				if (rejectDoubleClickOnCheckbox($checkboxEl)) {
					return false;
				}

				if ($checkboxEl.val() == "all" && $checkboxEl.prop("checked")) {
					$filterList
						.find(filterListItemCheckboxSelector)
						.not(allToggleSelector)
						.prop("checked", true);
				}

				const $categoryContainer = $filterableContainer.find(
					`.MeasuresByCategory--${$checkboxEl.val()}`,
				);
				if ($categoryContainer.length) {
					$categoryContainer.siblings(".MeasuresByCategory").addClass("hidden");
					animateFilterablesIn($categoryContainer);
					return;
				}
				// After any toggles from the all toggler
				const $allCheckableItemsExceptAll = $filterList
					.find(filterListItemCheckboxSelector)
					.not(allToggleSelector);
				const $checkedItems = checkedItemsIn($filterList);
				const checkedVals = checkedValsIn($filterList);

				// @ts-expect-error
				const prevState = $filterableContainer
					.attr("data-prev-selected")
					.split(",");
				const filterOutVals = prevState.filter((x) => !checkedVals.includes(x));

				if (filterOutVals.length) {
					const filterOutSelectors =
						createSelectorsFrom(filterOutVals).join(",");
					const $filterOutEls = $filterableContainer.find(
						`${filterableItemSelector}${filterOutSelectors}`,
					);
					animateFilterablesOut($filterOutEls);
				}

				setPrevState($filterableContainer, checkedVals);

				if ($checkedItems.length) {
					toggleSelectAllCheckboxIn(
						$filterList,
						$checkedItems,
						$allCheckableItemsExceptAll,
					);

					const filterSelectors = createSelectorsFrom(checkedVals).join(",");
					const $filterInEls = $filterableContainer.find(
						`${filterableItemSelector}${filterSelectors}`,
					);
					animateFilterablesIn($filterInEls);
				}
			},
		);

	// Init the first set
	if ($filterableContainer.find(".MeasuresByCategory").length) {
		window.setTimeout(function () {
			$filterList
				.find(filterListItemCheckboxSelector)
				.not(allToggleSelector)
				.first()
				.trigger("click");
		}, 200);
	} else {
		animateFilterablesOut($filterableContainer.find(filterableItemSelector));
		window.setTimeout(function () {
			$filterList
				.find(`${filterListItemCheckboxSelector}:checked`)
				.trigger("change");
		}, 200);
	}
}

export default { init };
